import * as React from "react";
import {
  TextField,
  ImageField,
  Show,
  usePermissions,
  useRecordContext,
  Title,
  FunctionField,
  ReferenceField,
  DateField,
  NumberField,
} from "react-admin";
import { ROLE_TYPES } from "../enums/Roles";
import { SimpleShowLayout } from "../common/SimpleShowLayout";

const ReviewTitle = () => {
  const record = useRecordContext();
  return (
    <Title
      title={`Calificación de ${record?.user?.firstName || ""} ${
        record?.user?.lastName || ""
      }`}
    />
  );
};

const ReviewShow = () => {
  const { permissions } = usePermissions();
  return (
    <Show title={<ReviewTitle />}>
      <SimpleShowLayout>
        {permissions === ROLE_TYPES.ADMIN && (
          <TextField source="id" label="ID" />
        )}
        <FunctionField
          source="user"
          label="Usuario"
          render={(record) =>
            `${record?.user?.firstName || ""} ${
              record?.user?.lastName || ""
            }` || "-"
          }
        />
        <ReferenceField
          label="Compra"
          reference="purchases"
          source="purchase"
          emptyText="-"
        >
          <TextField source="productData.name" label="Compra" />
        </ReferenceField>
        <ReferenceField
          label="Canje"
          reference="coupons"
          source="coupon"
          emptyText="-"
        >
          <TextField source="redeemedCoupon.product.name" label="Local" />
        </ReferenceField>
        {permissions === ROLE_TYPES.ADMIN && (
          <ReferenceField
            label="Local"
            reference="restaurants"
            source="restaurant"
          >
            <TextField source="name" label="Local" />
          </ReferenceField>
        )}
        <FunctionField
          source="rating"
          label="Calificación"
          render={(record) => {
            const stars = Array.from(Array(record?.rating)).map((r) => "⭐️");
            return `${stars?.join("")} (${record?.rating})`;
          }}
        />
        <TextField source="comment" label="Comentarios" />
        <NumberField source="likesCount" label="Útil" />
        <NumberField source="dislikesCount" label="No Útil" />
        <ImageField source="images" src="url" label="Imágenes" />
        <DateField
          source="createdAt"
          label="Fecha"
          showTime={true}
          emptyText="-"
        />
      </SimpleShowLayout>
    </Show>
  );
};

export default ReviewShow;
